<template>
  <div>
    <input type="checkbox"
           :id="id"
           :checked="value"
           @change="({target: {checked}}) => $emit('input',  as_number == true ? String(Number(checked)) : checked)">
    <span v-text="value? 'Oui': 'Non'"></span>
  </div>
</template>

<script>
  import 'plugins/switchery/js/switchery.min.js'

  export default {
    props: ["value", "as_number"],

    data () {
      return {
        id: _.uniqueId('switcher_'),
        switchery: null
      }
    },

    mounted () {
      this.$nextTick()
        .then(() => {
          this.switchery = new Switchery(document.querySelector("#" + this.id), { color: '#fb557a', size: 'small' })
        })
    },

    beforeDestroy () {
      $(this.switchery.switcher, this.$el).remove()
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Forms/Elements/SubElements/Switcher.vue